import { Checkbox } from '@src/common/components/Checkbox';
import { Stack } from '@src/common/components/Stack';
import { TextInput } from '@src/common/components/TextInput';
import { theme } from '@src/common/styles/Theme';
import { ShowInstructionsToClientField } from '@src/permits/fields/Fields';
import type { AddPermitTypeFormInputs } from '@src/permitTypesManager/AddPermitTypeFormInputs';
import { PermitInstructionsField } from '@src/permitTypesManager/permitTypeSections/PermitInstructionsField';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const PermitInstructionsSection = () => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    control,
  } = useFormContext<AddPermitTypeFormInputs>();

  return (
    <Stack direction="column" gap={theme.spacing['1']}>
      <TextInput
        label={t('permitTypesManager.addPermitType.instructions.placeholder')}
        {...register(PermitInstructionsField.fieldName)}
        error={
          errors.instructions && t(`formErrors.${errors.instructions.message}`)
        }
        multiline
        size="medium"
      />
      <Controller
        key={ShowInstructionsToClientField.fieldName}
        name={ShowInstructionsToClientField.fieldName}
        control={control}
        render={({ field }) => (
          <Checkbox
            label={t(
              'permitTypesManager.addPermitType.definition.showInstructionsToClient',
            )}
            onChange={(e) => {
              field.onChange(e.target.checked);
            }}
            checked={!!field.value}
            sx={{ my: -1 }}
          ></Checkbox>
        )}
      />
    </Stack>
  );
};
